import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle, Button, Box} from 'views/components';
import {TextCharLimit} from 'views/components';

import {Translate, translate} from 'views/module';

const ClientLeadNameEdit = (props) => {
  const [newValue, setNewValue] = React.useState('');

  const {
    clientLeadData,
    clientLeadBackend,
    isEditing,
    setIsEditing,
  } = props;

  const {clientLeadName} = clientLeadData;

  React.useEffect(() => {
    setNewValue(clientLeadName);
  }, [clientLeadName]);

  const onSave = () => {
    clientLeadBackend.detail.editName(newValue, () => {
      setIsEditing(false);
    });
  };

  const isValid = () => {
    return !Boolean(newValue);
  };

  const onClose = () => {
    setIsEditing(false);
  };

  return (
    <Dialog onClose={onClose} open={isEditing}>
      <DialogTitle onClose={onClose}>
        <Translate expression='clientLead.ClientLeadDetail.ChangeName.Title' />
      </DialogTitle>
      <DialogContent>
        <Box sx={{m: 1}}>
          <TextCharLimit
            label={translate('clientLead.ClientLeadDetail.ChangeName.ClientLeadName')}
            value={newValue}
            onChange={setNewValue}
            charLimit={180}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="primary" disabled={isValid()} onClick={onSave}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ClientLeadNameEdit.propTypes = {
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientLeadNameEdit);
